module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加退款记录",
      "width": "1000px"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "insertUserForm",
    staticClass: "form",
    attrs: {
      "label-width": 110,
      "model": _vm.formData,
      "rules": _vm.rules
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    on: {
      "on-blur": function($event) {
        return _vm.searchUserInfo(false)
      }
    },
    model: {
      value: (_vm.formData.uid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "uid", _vm._n($$v))
      },
      expression: "formData.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员姓名"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.user.nickname),
      callback: function($$v) {
        _vm.$set(_vm.user, "nickname", $$v)
      },
      expression: "user.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.user.mobile),
      callback: function($$v) {
        _vm.$set(_vm.user, "mobile", $$v)
      },
      expression: "user.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.user.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.user, "adviserName", $$v)
      },
      expression: "user.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.user.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.user, "studyAdviserName", $$v)
      },
      expression: "user.studyAdviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": _vm.lastTeacherLabel,
      "prop": "lastTchId",
      "required": _vm.refundTeacherRequired
    }
  }, [(!_vm.canSave) ? _c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.formData.lastTchName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lastTchName", $$v)
      },
      expression: "formData.lastTchName"
    }
  }) : _c('TeacherSelect', {
    attrs: {
      "category": [1, 2, 3],
      "label": _vm.formData.lastTchName
    },
    on: {
      "on-change": _vm.onTchChange
    },
    model: {
      value: (_vm.formData.lastTchId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lastTchId", $$v)
      },
      expression: "formData.lastTchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "对应老师外管"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.formData.tchAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tchAdviserName", $$v)
      },
      expression: "formData.tchAdviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册渠道"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.formData.regChannel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "regChannel", $$v)
      },
      expression: "formData.regChannel"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课时费",
      "prop": "lessonFee"
    }
  }, [_c('Input', {
    on: {
      "on-change": _vm.onFeeFieldChange
    },
    model: {
      value: (_vm.formData.lessonFee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lessonFee", _vm._n($$v))
      },
      expression: "formData.lessonFee"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "礼品费",
      "prop": "giftFee"
    }
  }, [_c('Input', {
    on: {
      "on-change": _vm.onFeeFieldChange
    },
    model: {
      value: (_vm.formData.giftFee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "giftFee", _vm._n($$v))
      },
      expression: "formData.giftFee"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手续费",
      "prop": "serviceFee"
    }
  }, [_c('Input', {
    on: {
      "on-change": _vm.onFeeFieldChange
    },
    model: {
      value: (_vm.formData.serviceFee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "serviceFee", _vm._n($$v))
      },
      expression: "formData.serviceFee"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "实际退款金额",
      "prop": "actualRefundAmount"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.actualRefundAmount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "actualRefundAmount", _vm._n($$v))
      },
      expression: "formData.actualRefundAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "其他扣款",
      "prop": "otherAmount"
    }
  }, [_c('Input', {
    on: {
      "on-change": _vm.onFeeFieldChange
    },
    model: {
      value: (_vm.formData.otherAmount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "otherAmount", _vm._n($$v))
      },
      expression: "formData.otherAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退款账号",
      "prop": "refundAccount"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.refundAccount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "refundAccount", $$v)
      },
      expression: "formData.refundAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退款原因",
      "prop": "refundReason"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.refundReason),
      callback: function($$v) {
        _vm.$set(_vm.formData, "refundReason", $$v)
      },
      expression: "formData.refundReason"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退款原因分类",
      "prop": "refundReasonCategory"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.refundReasonCategory),
      callback: function($$v) {
        _vm.$set(_vm.formData, "refundReasonCategory", $$v)
      },
      expression: "formData.refundReasonCategory"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("外教原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("学导原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("销售原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("技术原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 5
    }
  }, [_vm._v("产品原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 6
    }
  }, [_vm._v("学生客观原因")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "备注",
      "prop": "refundRemark"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.refundRemark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "refundRemark", $$v)
      },
      expression: "formData.refundRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "orderId"
    }
  }), _vm._v(" "), _c('Form-item', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "prop": "courseUnitPrice"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.canSave) ? _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsertUser
    },
    on: {
      "click": _vm.insert
    }
  }, [_vm._v("保存")]) : _vm._e()], 1), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedOrderListChange
    },
    model: {
      value: (_vm.checkedList),
      callback: function($$v) {
        _vm.checkedList = $$v
      },
      expression: "checkedList"
    }
  }, [_c('table', {
    staticClass: "track-list"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("订单编号")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("订单金额")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("订单课时")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("教材金额")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("开票金额")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("合计课节")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("累计消耗")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("补课次数")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("课时单价")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("消耗")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataList), function(item, index) {
    return _c('tr', [_c('td', [_c('el-checkbox', {
      attrs: {
        "label": item.orderSn
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.orderAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.orderCourseNum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.textAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.invoiceAmount))]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": index == 0 ? _vm.colSpan : 0,
        "hidden": index != 0
      }
    }, [_vm._v(_vm._s(item.taotalCourseNum))]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": index == 0 ? _vm.colSpan : 0,
        "hidden": index != 0
      }
    }, [_vm._v(_vm._s(item.costCourseNum))]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": index == 0 ? _vm.colSpan : 0,
        "hidden": index != 0
      }
    }, [_vm._v(_vm._s(item.makeupNum))]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": index == 0 ? _vm.colSpan : 0,
        "hidden": index != 0
      }
    }, [_c('Input', {
      attrs: {
        "readonly": !_vm.canSave
      },
      on: {
        "on-change": _vm.onUnitPriceChange
      },
      model: {
        value: (_vm.formData.courseUnitPrice),
        callback: function($$v) {
          _vm.$set(_vm.formData, "courseUnitPrice", _vm._n($$v))
        },
        expression: "formData.courseUnitPrice"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": index == 0 ? _vm.colSpan : 0,
        "hidden": index != 0
      }
    }, [_vm._v(_vm._s(_vm.displayCostAmount))])])
  }), 0)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ce35c01","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/financial/modal/RefundInsertModal.vue
// module id = 1667
// module chunks = 8